import { Session } from './components';
import { sessionContainer } from './containers';

const SessionContainer = sessionContainer(Session);

export { SessionContainer as Session };
